import { $$ } from './helper'

window.youtubeNotReady = true

export class Video {
  constructor () {
    this.selectors = {
      video: '.video',
      vimeoContainer: '.video__container--vimeo',
      youtubeContainer: '.video__container--youtube',
      previewImage: '.video__preview-image'
    }

    this.classes = {
      showCookieNote: 'video--show-cookie-note',
      youtubePlayer: 'video__youtube-player',
      previewImage: 'video__preview-image',
      hidePreviewImage: 'video__preview-image--hide'
    }
  }

  init () {
    this.videos = $$(this.selectors.video)
  }

  checkCookie () {
    if ((window.name === 'newTYPO3frontendWindow') || (Cookiebot.consent !== undefined && Cookiebot.consent.preferences)) {
      this.showYoutube()
      this.showVimeo()
      if (this.videos !== undefined) {
        this.videos.forEach(video => {
          video.classList.remove(this.classes.showCookieNote)
        })
      }
    } else {
      if (this.videos !== undefined) {
        this.videos.forEach(video => {
          video.classList.add(this.classes.showCookieNote)
        })
      }
      this.removeVimeo()
      this.removeYoutube()
    }
  }

  showVimeo () {
    const vimeoIframes = $$(this.selectors.vimeoContainer + ' iframe')

    vimeoIframes.forEach(vimeoIframe => {
      vimeoIframe.src = vimeoIframe.dataset.src
    })
  }

  removeVimeo () {
    const vimeoIframes = $$(this.selectors.vimeoContainer + ' iframe')

    vimeoIframes.forEach(vimeoIframe => {
      vimeoIframe.src = ''
    })
  }

  removeYoutube () {
    const youtubeIframes = $$(this.selectors.youtubeContainer + ' iframe')
    const previewImages = $$(this.selectors.youtubeContainer + ' ' + this.selectors.previewImage)

    youtubeIframes.forEach(youtubeIframe => {
      const defaultContainer = document.createElement('div')

      defaultContainer.dataset.uid = youtubeIframe.dataset.uid
      defaultContainer.dataset.videoId = youtubeIframe.dataset.videoId
      defaultContainer.classList.add(this.classes.youtubePlayer)
      defaultContainer.id = youtubeIframe.id

      youtubeIframe.after(defaultContainer)
      youtubeIframe.remove()
    })

    previewImages.forEach(previewImage => {
      previewImage.classList.remove(this.classes.hidePreviewImage)

      const newPreviewImage = document.createElement('div')
      newPreviewImage.classList.add(this.classes.previewImage)
      newPreviewImage.style.backgroundImage = previewImage.style.backgroundImage

      previewImage.after(newPreviewImage)
      previewImage.remove()
    })
  }

  showYoutube () {
    const that = this

    $('.video__container--youtube')
      .each(function () {
        if (!($('#yt-api').length > 0)) {
          const tag = document.createElement('script')

          tag.setAttribute('id', 'yt-api')
          tag.src = 'https://www.youtube.com/iframe_api'
          const firstScriptTag = document.getElementsByTagName('script')[0]
          firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
        }

        if (window.youtubeNotReady === false) {
          that.initYoutube()
        } else {
          window.onYouTubeIframeAPIReady = function () { // eslint-disable-line no-unused-vars
            window.youtubeNotReady = false
            that.initYoutube()
          }
        }
      })
  }

  initYoutube () {
    const that = this
    const videoRatio = 16 / 9

    const onPlayerError = function (event) {
      event.target.destroy()
    }

    $('.video__youtube-player').each(function () {
      const videoId = $(this).data('video-id')
      let captions = 1
      if ($(this).data('hide-captions') && $(this).data('hide-captions') !== 0) {
        captions = 0
      }
      const thisPlayer = $(this).parent()
      const contentWidth = $(this).outerWidth()
      thisPlayer.css('min-height', (contentWidth / videoRatio))

      const onPlayerReady = function (event) {
        const playerContent = thisPlayer.find(that.selectors.previewImage)

        playerContent.append('<i></i>')
        playerContent.on('click', function clickImage () {
          $(this).addClass(that.classes.hidePreviewImage)
          event.target.playVideo()
        })
      }

      new YT.Player(this, { // eslint-disable-line no-new, no-undef
        width: contentWidth,
        height: (contentWidth / videoRatio),
        videoId,
        host: 'https://www.youtube-nocookie.com',
        playerVars: {
          rel: 0,
          showinfo: 0,
          ecver: 2,
          cc_load_policy: captions
        },
        events: {
          onReady: onPlayerReady,
          onError: onPlayerError
        }
      })
    })
  }
}

export default Video
